import { createStore } from 'vuex'
import { markRaw } from 'vue'

export default createStore({
    state: {
        auth: null,
        user: { name: 'John Doe' },
        modals: [],
        popups: [],
        navigation: { active: false },
        checkedIn: { work: false, job: null, paused: false },
        stamps: [],
        image: null,
        news: [],
        fileOverlayUrl: null,
        cameraActive: false,
        cameraUrl: null
    },
    mutations: {
        image(state, image) {
            state.image = image
        },
        stamps(state, stamps) {
            state.stamps = stamps
        },
        user(state, user) {
            state.user = user
        },
        auth(state, auth) {
            state.auth = auth
            localStorage.setItem('auth', auth)
        },
        pushModal(state, modal) {
            console.log('pushing modal', modal)

            state.modals.push(modal)
        },
        popModal(state) {
            state.modals.pop()
        },
        pushPopup(state, modal) {
            console.log('pushing popup', modal)

            //modal.options = markRaw(modal.options || {})

            state.popups.push(modal)
        },
        popPopup(state) {
            state.popups.pop()
        },
        clearPopup(state) {
            state.popups = []
        },
        navigation(state, navigation) {
            state.navigation = navigation
        },
        jobCheckIn(state, job) {
            state.checkedIn.paused = false
            state.checkedIn.job = job
        },
        jobCheckOut(state) {
            state.checkedIn.job = null
        },
        jobPause(state) {
            state.checkedIn.paused = true
        },
        jobResume(state) {
            state.checkedIn.paused = false
        },
        workCheckIn(state) {
            state.checkedIn.work = true
        },
        workCheckOut(state) {
            state.checkedIn.work = false
        },
        news(state, news) {
            state.news = news
        },
        openFileOverlay(state, url) {
            state.fileOverlayUrl = url;
        },
        closeFileOverlay(state) {
            state.fileOverlayUrl = null;
        },
        cameraActive(state, active) {
            state.cameraActive = active;
        },
        cameraUrl(state, url) {
            state.cameraUrl = url;
        }
    },
    getters: {
        stamps: state => state.stamps,
        auth: state => state.auth,
        user: state => state.user,
        modals: state => state.modals,
        popups: state => state.popups,
        navigation: state => state.navigation,
        checkedIn: state => state.checkedIn,
        news: state => state.news,
        unreadNews: state => state.news.filter(news => news._embedded.highlight),
        fileOverlayUrl: state => state.fileOverlayUrl,
        cameraActive: state => state.cameraActive,
        cameraUrl: state => state.cameraUrl
    },
    actions: {
        updateNews({ commit }) {
            this.axios.get('news').then(response => {
                commit('news', response.data._items)
            }).catch(e => {
				console.error('Failed to fetch news', e)
			})
        }
    }
})
